import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { isEmpty } from '../../helpers';
import { StyledFieldLabel, StyledTextField } from './styled';

type PropsType = {
  disabled: boolean;
  value: string;
  onChange: (value: string) => void;
  onValidationChange: (isValid: boolean) => void;
};

const TRACK_GENERATIONS_REGEX = /^[1-9]\d*$/;

const TrackGenerationsField = ({
  disabled,
  value,
  onChange,
  onValidationChange,
}: PropsType) => {
  const [error, setError] = useState<Error | null>(null);

  const validateTrackGenerations = (generations: string) => {
    const trimmedGenerations = generations.trim();
    if (isEmpty(trimmedGenerations)) {
      setError(null);
      return;
    }

    if (!TRACK_GENERATIONS_REGEX.test(trimmedGenerations)) {
      setError(Error('Please enter a valid number greater than 0'));
    } else {
      setError(null);
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    onChange(newValue);
    validateTrackGenerations(newValue);
  };

  useEffect(() => {
    onValidationChange(!error && !isEmpty(value));
  }, [error, value, onValidationChange]);

  return (
    <Box>
      <StyledFieldLabel>Desired monthly track generations</StyledFieldLabel>
      <StyledTextField
        placeholder="e.g., 1000"
        value={value}
        disabled={disabled}
        variant="outlined"
        error={!!error}
        helperText={error && error.message}
        onChange={handleChange}
      />
    </Box>
  );
};

export default TrackGenerationsField;
